import { render, staticRenderFns } from "./StockListaItemProducto.vue?vue&type=template&id=3bf2f7b4&"
import script from "./StockListaItemProducto.vue?vue&type=script&lang=js&"
export * from "./StockListaItemProducto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports